import axios from 'lib/axios'

export interface Test360Answer {
  assignment_id: number
  response_weight: number
}

export interface Test360Question {
  question_id: number
  answers: Test360Answer[]
}

export interface Test360Competency {
  competency_id: number
  questions: Test360Question[]
}

export interface Test360AnswersBody {
  test360: Test360Competency[]
}

const test360CreateAnswersDraft = async (userTestId: number, body: Test360AnswersBody) => {
  const apiUrl = `/test360/draft/answers/${userTestId}`

  try {
    const response = await axios.patch(apiUrl, body)
    return response.data
  } catch (error) {
    console.error('error creating test 360 answers draft', error)
    throw error
  }
}

export default test360CreateAnswersDraft
